import {reduxProps} from '../../constants'
import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {actionGetStoryQuestions} from '../../redux/education'
import {OrderQuestion} from '../Question/OrderQuestion'
import {MatchQuestion} from '../Question/MatchQuestion'
import {Modal} from 'react-bootstrap'
import {
  actionQuestionDetailModalClose,
  actionStoryDetailModalClose,
  actionStoryDetailModalOpen
} from "../../redux/modal";

export function QuizDetail() {
  const dispatch = useDispatch()
  const {questionDetailModalField, questionDetailModalOpen} = useSelector(
    (state: reduxProps) => state.modalReducer
  )
  const [questions, setQuestions] = useState([] as any)

  useEffect(() => {
    if (!questionDetailModalOpen) return
    dispatch(
      actionGetStoryQuestions(
        {
          StoryId: questionDetailModalField.StoryId,
          LanguageCode: questionDetailModalField.LanguageCode,
          ShowType:""
        },
        (r) => {
          setQuestions(r.payload.data)
          if (r.type !== 'SUCCESS') {
            return
          }
        }
      )
    )
    if (questionDetailModalField.ShowType==="StoryDetailModal"){
      dispatch(actionStoryDetailModalClose())
    }
  }, [questionDetailModalOpen])

  const getOptionStringName = (queueNo: any) => {
    switch (queueNo) {
      case 1:
        return 'a'
      case 2:
        return 'b'
      case 3:
        return 'c'
      default:
      // code block
    }
  }

  const handleClose = () => {
    if (questionDetailModalField.ShowType === "StoryDetailModal"){
      dispatch(
        actionStoryDetailModalOpen({
          StoryId: questionDetailModalField.StoryId,
          StoryDetailId: 0,
          LanguageCode:questionDetailModalField.LanguageCode,
        })
      )
    }
    dispatch(actionQuestionDetailModalClose())
  }

  if (
    !questionDetailModalOpen &&
    questionDetailModalField.StoryId &&
    questionDetailModalField.StoryId > 0
  ) {
    return <>asdasd</>
  } else {
    return (
      <>
        <Modal show={questionDetailModalOpen} onHide={handleClose} size={'lg'} className={'p-0'}>
          <Modal.Body className={"p-0"}>
            <div className={'question-detail d-flex flex-column'}>
              <div className={"header-area col-md-12"}>
                <button
                  className="btn btn-icon btn-sm btn-active-light-primary mt-2 ms-5 float-left"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleClose}
                >
                  <i className="fa-solid fa-chevron-left fs-3"></i><span className={"back-text"}> Geri</span>
                </button>
                <button
                  className="btn btn-icon btn-sm btn-active-light-primary me-2 mt-2 float-right"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleClose}
                >
                  <i className="fa-solid fa-xmark fs-3"></i>
                </button>
              </div>
              <div className={"content-body"}>
                {questions &&
                  questions?.sort((a: { queueNo: number; }, b: {
                    queueNo: number;
                  }) => a.queueNo - b.queueNo).map((question: any, index: any) => {
                    return (
                      <div>
                        <h2 className={"questionHeadTitle"}>{index + 1}. Soru</h2>
                        <h3 dangerouslySetInnerHTML={{ __html: question.title }}></h3>
                        {  question?.generalOptions?.map ((option: any, index: number) => {
                            return (
                              <div
                                className={`questionOption ${option.trueOption && 'trueOption'}`}
                              >
                                {option.trueOption && (
                                  <i className={'icon fa-solid ' + 'fa-check'}></i>
                                )}
                                <span>{getOptionStringName(index + 1)}</span>
                                <label>{option.title}</label>
                              </div>
                            )
                          })
                        }
                        {question.questionTypeId == 2 && (
                          <OrderQuestion options={question.matchOptions} />
                        )}
                        {question.questionTypeId == 3 && (
                          <MatchQuestion options={question.matchOptions} />
                        )}
                      </div>
                    )
                  })}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}
